import { LandingCtaSection } from "@/components/landing/cta-section";
import { LandingHeroSection } from "@/components/landing/hero-section";
import { LandingHowItWorksSection } from "@/components/landing/how-it-works-section";
import { LandingMealDeciderSection } from "@/components/landing/meal-decider-section";

export default function Home() {
  return (
    <main className="bg-[#f7f4ee] text-[#111111]">
      <LandingHeroSection />
      <LandingHowItWorksSection />
      <LandingMealDeciderSection />
      <LandingCtaSection />
    </main>
  );
}
